export const enum Socials {
  TG = 'tg',
  VK = 'vk',
  YT = 'yt',
  OK = 'ok',
  IN = 'in',
  FB = 'fb',
  TW = 'tw',
  DZ = 'dz',
  TT = 'tt',
}

export type ISocialLinks = {
  [key in Socials]?: {
    url: string;
    order: string;
  };
};
